import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useLocation } from 'react-router-dom';

export type PrimiteContextProps = {
  chapterId?: number;
  lessonId?: number;
  bookId?: number;
  conversationId?: number;
};

type ChatBotContextProps = {
  setContext: (context: PrimiteContextProps) => void;
  getContext: () => PrimiteContextProps | undefined;
};

const ChatBotContext = createContext<ChatBotContextProps>(
  {} as ChatBotContextProps,
);

export const ChatBotProvider = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();

  const context = useRef<PrimiteContextProps | null>(null);

  const setContext = (contextParams: PrimiteContextProps) => {
    context.current = {
      ...context.current,
      ...contextParams,
    };
  };

  const getContext = () => {
    return context.current ?? undefined;
  };

  useEffect(() => {
    if (pathname === '/login') {
      context.current = null;
    }
  }, [pathname]);

  return (
    <ChatBotContext.Provider
      value={{
        setContext,
        getContext,
      }}
    >
      {children}
    </ChatBotContext.Provider>
  );
};

export const useChatBotContext = () => {
  return useContext(ChatBotContext);
};

export default ChatBotContext;
